import { render } from "./Viewer.vue?vue&type=template&id=f8c5c798&scoped=true"
import script from "./Viewer.vue?vue&type=script&lang=js"
export * from "./Viewer.vue?vue&type=script&lang=js"

import "./Viewer.vue?vue&type=style&index=0&id=f8c5c798&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c5c798"]])

export default __exports__